import React from "react";

/**
 * redirector needed for /apply/$jobId and /jobs/$jobId. this is needed for greenhouse as new jobs created there contain
 * that structure and cannot be changed. it also can't be handled in nginx as we don't want to mess with that config.
 * also we can't use gatsby-navigation because it triggers the transition functionality.
 *
 * /apply/$jobId redirects to /job/$jobSlug#form
 * /jobs/$jobId redirects to /job/$jobSlug
 */
class Job extends React.Component {
  componentDidMount() {
    if (this.props.location.pathname.includes("apply") === true) {
      window.location.href = `${window.location.pathname}#form`;
    }

    window.location.pathname = `/job/${this.props.pageContext.slug}-${
      this.props.pageContext.id
    }`;
  }

  render() {
    return null;
  }
}

export default Job;
